// @ts-nocheck
import {
  FETCH_PLATFORMS_FULFILLED,
  FETCH_PLATFORMS_REJECTED,
  FETCH_SERVICE_MESSAGES_FULFILLED,
  FETCH_SERVICE_MESSAGES_REJECTED,
} from './messageActionTypes';

const initialState = {
  serviceMessages: null,
  platforms: null,
};

export default function messageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_SERVICE_MESSAGES_FULFILLED:
      return {
        ...state,
        serviceMessages: action.payload,
      };
    case FETCH_SERVICE_MESSAGES_REJECTED:
      return {
        ...state,
        serviceMessages: null,
      };
    case FETCH_PLATFORMS_FULFILLED:
      return {
        ...state,
        platforms: action.payload,
      };
    case FETCH_PLATFORMS_REJECTED:
      return {
        ...state,
        platforms: null,
      };
    default:
      return state;
  }
}
